import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { doImpersonate, getUser } from "../../actions/auth";
import { fetchUserInfo } from "../../actions/users";
import { appModal } from "../../helpers/interactions";
import { hasPermission } from "../../helpers/permissions";
import { getParameterByName } from "../../helpers/util";

class ImpersonateAlertModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    user: null,
  };

  componentDidMount() {
    this.mounted = true;
    this.checkImpersonate();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.checkImpersonate();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.impersonateRequest += 1;
  }

  impersonateRequest = 0;

  canImpersonate(user) {
    return !!user && hasPermission("users", "impersonate", user);
  }

  checkImpersonate() {
    const user = getUser();
    if (!this.canImpersonate(user)) {
      return;
    }
    const impersonate = getParameterByName("impersonate");
    if (impersonate !== null && impersonate !== "" && !this.state.user && user.id !== Number(impersonate)) {
      const request = ++this.impersonateRequest;
      fetchUserInfo(impersonate).then((user) => {
        if (!this.mounted || request !== this.impersonateRequest) {
          return;
        }
        this.setState({ user }, () => {
          appModal("#ImpersonateAlertModal", "show");
        });
      });
    }
  }

  impersonate = () => {
    this.props.dispatch(doImpersonate(this.state.user));
    this.setState({ user: null });
  };

  render() {
    const user = this.state.user || {};
    return (
      <div
        id="ImpersonateAlertModal"
        aria-labelledby="ImpersonateAlertModal-title"
        className="modal fade modal-fade-in-scale-up"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title" id="ImpersonateAlertModal-title">
                Impersonate {user.first_name} {user.last_name}
              </h4>
            </div>
            <div className="modal-body">
              <h5>
                We noticed that you may want to impersonate {user.first_name} {user.last_name} to continue your actions.
              </h5>
              <button
                onClick={this.impersonate}
                type="button"
                className="app-btn btn-round app-btn--info waves-effect waves-light"
              >
                Impersonate
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ImpersonateAlertModal);
